import { authHeader, handleResponse } from "../helper/auth-header";

export default class StockSummaryService {
  ControllerName = "StockSummary";

  async GetStockSummary(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetStockSummary`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetBatchTracking(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetBatchTracking`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
